/*
 * @Author: monai
 * @Date: 2021-05-08 18:19:57
 * @LastEditors: yexiu
 * @LastEditTime: 2024-05-29 11:10:17
 */
import { ref, toRefs, watch, defineComponent } from 'vue';

export default defineComponent({
	props: {
		config: {
			type: Object,
			default: () => ({})
		}
	},
	setup(props) {
		let toastConfig = toRefs(props.config as DevelopToolShare.ToastConfig), timeID = ref(-1);
		let { text, visible, showTime, style } = toastConfig;

		watch(visible, newValue => {
			if (newValue) {
				timeID.value = window.setTimeout(() => { visible.value = false; }, showTime.value);
			} else {
				clearTimeout(timeID.value);
			}
		});
		return { style, text, visible };
	}
})